import { render } from "./InstructionsTable.vue?vue&type=template&id=30443547"
import script from "./InstructionsTable.vue?vue&type=script&lang=js"
export * from "./InstructionsTable.vue?vue&type=script&lang=js"

import "./InstructionsTable.vue?vue&type=style&index=0&id=30443547&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__